export default __webpack_public_path__ + "static/media/pantry1-afterE-768w.e2e77135.webp";